import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { id: "header__main" }
const _hoisted_2 = { class: "row g-0" }
const _hoisted_3 = ["innerHTML"]

import MegaMenu from '@/components/BaseHeader/BaseHeaderMegaMenu.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseHeaderMain',
  props: {
  items: {
    type: Array,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_IoRouterLink = _resolveComponent("IoRouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (menuItem) => {
        return (_openBlock(), _createElementBlock("div", {
          key: `main-${menuItem.id}`,
          class: "col-auto"
        }, [
          _createVNode(_component_IoRouterLink, {
            "link-url": menuItem.url,
            "link-target": menuItem.target,
            "link-title": menuItem.titleAttr,
            id: `iomi-${ menuItem.id }`,
            active: menuItem.active
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", {
                innerHTML: menuItem.title
              }, null, 8, _hoisted_3)
            ]),
            _: 2
          }, 1032, ["link-url", "link-target", "link-title", "id", "active"]),
          (menuItem.children)
            ? (_openBlock(), _createBlock(MegaMenu, {
                key: 0,
                parent: menuItem,
                items: menuItem.children || []
              }, null, 8, ["parent", "items"]))
            : _createCommentVNode("", true)
        ]))
      }), 128)),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "col" }, null, -1))
    ])
  ]))
}
}

})